import { render, staticRenderFns } from "./WebGLTeamplate.vue?vue&type=template&id=9f96c34a&"
import script from "./WebGLTeamplate.vue?vue&type=script&lang=js&"
export * from "./WebGLTeamplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports